import { isSuburban } from '../category/isSuburban';
import { getLandArea } from '../area/getLandArea';
import { IOffer } from '../../../types/offer';

/**
 * получение подзаголовка для загородной недвижимости
 */
export function getLandAreaTitle(offer: IOffer): string | undefined {
  if (!isSuburban(offer)) {
    return undefined;
  }

  return getLandArea(offer);
}
